import React from "react";
import useBrowserInfo from "modules/common/hooks/useBrowserInfo";
import { browserNames } from "modules/common/constants/browserAgentParsing";
import { useBroadcastVideoActions } from "./hooks/useBroadcastVideoActions";

const BroadcastVideoSubscriber = () => {
  const { subscribe, unsubscribe } = useBroadcastVideoActions();
  const { browser } = useBrowserInfo();
  const listener = () => {
    if (document.visibilityState === "visible") {
      subscribe();
    } else {
      unsubscribe();
    }
  };

  const isSafari = browser.isBrowser(browserNames.SAFARI);

  React.useEffect(() => {
    subscribe();

    /*
    NOTE: Safari sometimes does not fire visibilitychange as expected when
          the value of visibilityState property transitions to hidden.
          Workaround is to use pagehide event just for safari but in this
          particular situation doing unsubscibe on hidden is not critical
          because in subscribe we always unscribe first.
    */
    if (isSafari) {
      document.addEventListener("visibilitychange", listener);
    }

    return () => {
      unsubscribe();

      if (isSafari) {
        document.removeEventListener("visibilitychange", listener);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default BroadcastVideoSubscriber;
